export const quadVert = `
precision mediump float;

varying vec2 vUv;

void main() {
  vUv = uv;
  gl_Position = vec4(position, 1.0);
}
`;

export const quadFrag = `
precision mediump float;

uniform sampler2D tDiffuse;
uniform sampler2D maskTex;
uniform float reverse;

varying vec2 vUv;

void main() {
  vec4 mask = texture2D(maskTex, vUv);
  vec4 scene = texture2D(tDiffuse, vUv);
  float opacity = reverse > 0.5 ? 1. - mask.a : mask.a;

  if (opacity == 0.) {
    discard;
  }

  gl_FragColor = vec4(scene.rgb, 1.);
}`